export function showModalMessageSent() {
	app.modal.open('#modal-message-sent');
}
